/**
 * i18next keys for the texts shown by the shared portal auth components (PortalLogin,
 * PortalForgotPassword and PortalPasswordReset). Each key can be overridden so a component can
 * be reused with different texts (for example the customer portal vs the company portal).
 *
 * These live in a separate (non-component) file so the components keep working with React fast
 * refresh.
 */

export interface PortalLoginTranslationKeys {
    header: string;
    pleaseLogin: string;
    loginFailure: string;
    emailLabel: string;
    passwordLabel: string;
    forgotPassword: string;
    loginButton: string;
    legalNotice: string;
    footer: string;
    oidcLogin: string;
}

export const DEFAULT_PORTAL_LOGIN_KEYS: PortalLoginTranslationKeys = {
    header: 'portal.login.header',
    pleaseLogin: 'portal.login.please-login',
    loginFailure: 'portal.login.login-failure',
    emailLabel: 'portal.login.email-label',
    passwordLabel: 'portal.login.password-label',
    forgotPassword: 'portal.login.forgot-password',
    loginButton: 'portal.login.login-button',
    legalNotice: 'portal.legal-notice',
    footer: 'portal.login.footer',
    oidcLogin: 'portal.login.oidc-login'
};

export interface PortalForgotPasswordTranslationKeys {
    header: string;
    title: string;
    resetSent: string;
    emailLabel: string;
    customText: string;
    resetButton: string;
    footer: string;
}

export const DEFAULT_PORTAL_FORGOT_PASSWORD_KEYS: PortalForgotPasswordTranslationKeys = {
    header: 'portal.forgot-password.header',
    title: 'portal.forgot-password.title',
    resetSent: 'portal.forgot-password.reset-sent',
    emailLabel: 'portal.forgot-password.email-label',
    customText: 'portal.forgot-password.custom-text',
    resetButton: 'portal.forgot-password.reset-button',
    footer: 'portal.forgot-password.footer',
};

export interface PortalPasswordResetTranslationKeys {
    resetDataMissing: string;
    passwordMismatch: string;
    securityQuestionHeader: string;
    securityQuestionText: string;
    securityAnswerLabel: string;
    header: string;
    title: string;
    emailLabel: string;
    passwordLabel: string;
    passwordRepeatLabel: string;
    setPasswordButton: string;
    footer: string;
}

export const DEFAULT_PORTAL_PASSWORD_RESET_KEYS: PortalPasswordResetTranslationKeys = {
    resetDataMissing: 'portal.password-reset.reset-data-missing',
    passwordMismatch: 'portal.password-reset.password-mismatch',
    securityQuestionHeader: 'portal.password-reset.security-question-header',
    securityQuestionText: 'portal.password-reset.security-question-text',
    securityAnswerLabel: 'portal.password-reset.security-answer-label',
    header: 'portal.password-reset.header',
    title: 'portal.password-reset.title',
    emailLabel: 'portal.password-reset.email-label',
    passwordLabel: 'portal.password-reset.password-label',
    passwordRepeatLabel: 'portal.password-reset.password-repeat-label',
    setPasswordButton: 'portal.password-reset.set-password-button',
    footer: 'portal.password-reset.footer',
};
